export default "__VITE_ASSET__$ValS0OP__"